import { GameMenuState } from 'enums/GameMenuState';

export const enum GameActionType {
    OpenWidget = 'GAME/OPEN_WIDGET',
    Start = 'GAME/START',
    Stop = 'GAME/STOP',
    Pause = 'GAME/PAUSE',
    Resume = 'GAME/RESUME',
    SetShowStarter = 'GAME/SET_SHOW_STARTER',
    ResetStarterWasShown = 'GAME/RESET_STARTER_WAS_SHOWN',
    SetScore = 'GAME/SET_SCORE',
    SetVolume = 'GAME/SET_VOLUME',
    SetOver = 'GAME/SET_OVER',
    StartHints = 'GAME/START_HINTS',
    NextHint = 'GAME/NEXT_HINT',
    FlushQueuedGameActions = 'GAME/FLUSH_QUEUED_GAME_ACTIONS',
    SetGameMenuState = 'GAME/SET_GAME_MENU_STATE',
}

export type OpenGameWidgetAction = ReturnType<typeof openGameWidget>;
export const openGameWidget = ({ isInitiatedByDeepLink }: { isInitiatedByDeepLink: boolean }) => ({
    type: GameActionType.OpenWidget,
    payload: isInitiatedByDeepLink,
});

export type StartGameAction = ReturnType<typeof startGame>;
export const startGame = () => ({
    type: GameActionType.Start,
});

export type StopGameAction = ReturnType<typeof stopGame>;
export const stopGame = () => ({
    type: GameActionType.Stop,
});

export type PauseGameAction = ReturnType<typeof pauseGame>;
export const pauseGame = () => ({
    type: GameActionType.Pause,
});

export type ResumeGameAction = ReturnType<typeof resumeGame>;
export const resumeGame = () => ({
    type: GameActionType.Resume,
});

export type SetShowGameStarterAction = ReturnType<typeof setShowGameStarter>;
export const setShowGameStarter = (show: boolean) => ({
    type: GameActionType.SetShowStarter,
    payload: show,
});

export type ResetGameStarterWasShownAction = ReturnType<typeof resetGameStarterWasShown>;
export const resetGameStarterWasShown = () => ({
    type: GameActionType.ResetStarterWasShown,
});

export type SetGameScoreAction = ReturnType<typeof setGameScore>;
export const setGameScore = (score: number, duration: number) => ({
    type: GameActionType.SetScore,
    payload: { score, duration },
});

export type SetGameVolumeAction = ReturnType<typeof setGameVolume>;
export const setGameVolume = (volume: number) => ({
    type: GameActionType.SetVolume,
    payload: volume,
});

export type SetGameOverAction = ReturnType<typeof setGameOver>;
export const setGameOver = (over: boolean) => ({
    type: GameActionType.SetOver,
    payload: over,
});

export type NextGameHintAction = ReturnType<typeof nextGameHint>;
export const nextGameHint = () => ({
    type: GameActionType.NextHint,
});

export type StartGameHintsAction = ReturnType<typeof startGameHints>;
export const startGameHints = () => ({
    type: GameActionType.StartHints,
});

export type FlushQueuedGameActionsAction = ReturnType<typeof flushQueuedGameActions>;
export const flushQueuedGameActions = () => ({
    type: GameActionType.FlushQueuedGameActions,
});

export type SetGameMenuState = ReturnType<typeof setGameMenuState>;
export const setGameMenuState = (gameMenuState: GameMenuState) => ({
    type: GameActionType.SetGameMenuState,
    payload: gameMenuState,
});
